import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Use AntD Theme Editor @  https://ant.design/theme-editor#component-color
import { theme } from 'antd';
var sharedTokens = {
  fontSize: 14,
  fontSizeSM: 12,
  fontSizeLG: 16,
  fontSizeXL: 20,
  fontSizeHeading1: 38,
  fontSizeHeading2: 30,
  fontSizeHeading3: 24,
  fontSizeHeading4: 20,
  fontSizeHeading5: 16,
  colorPrimary: '#122048',
  colorInfo: '#122048',
  colorLink: '#19a6e0',
  //colorSuccess: '#3fa142',
  //colorError: '#f44336',
  borderRadius: 6,
  borderRadiusXS: 2,
  borderRadiusSM: 4,
  borderRadiusLG: 8,
  wireframe: false
};
var sharedComponents = {
  Button: {
    colorPrimary: 'rgb(240, 75, 36)'
  },
  Tabs: {
    itemSelectedColor: 'rgb(240, 75, 36)',
    inkBarColor: 'rgb(240, 75, 36)'
  },
  Card: {
    borderRadiusLG: 8,
    fontSizeLG: 20
  },
  Tag: {
    borderRadiusSM: 8
  },
  Typography: {
    fontFamilyCode: 'Nirmala, Roboto',
    titleMarginTop: '0em',
    titleMarginBottom: '01em',
    fontSizeHeading1: 18,
    lineHeightHeading1: 1,
    fontSizeHeading2: 17,
    lineHeightHeading2: 1,
    fontSizeHeading3: 16,
    lineHeightHeading3: 1,
    fontSizeHeading4: 15,
    lineHeightHeading4: 1,
    fontSizeHeading5: 14,
    lineHeightHeading5: 1
  }
};
export var lightThemeData = {
  token: _objectSpread(_objectSpread({}, sharedTokens), {}, {
    colorText: 'rgba(0,0,0,0.88)'
  }),
  components: _objectSpread(_objectSpread({}, sharedComponents), {}, {
    Menu: {
      groupTitleColor: 'rgb(25, 166, 224)',
      itemColor: 'rgb(25, 166, 224)',
      itemHoverColor: 'rgb(25, 166, 224)',
      itemSelectedBg: 'rgb(245, 245, 245)',
      itemSelectedColor: 'rgb(25, 166, 224)',
      subMenuItemBg: 'rgba(255, 255, 255, 0.04)'
    },
    Select: {
      colorPrimaryHover: 'rgb(245, 245, 245)',
      multipleItemBg: 'rgba(245, 245, 245, 0)',
      optionSelectedColor: 'rgb(18, 32, 72)',
      optionSelectedBg: 'rgb(245, 245, 245)'
    },
    Tag: {
      defaultColor: 'rgba(0,0,0,0.70)'
    },
    Dropdown: {
      controlItemBgActive: 'rgb(197, 203, 209)',
      controlItemBgActiveHover: 'rgb(192, 198, 204)'
    }
  })
};
export var darkThemeData = {
  algorithm: theme.darkAlgorithm,
  token: _objectSpread(_objectSpread({}, sharedTokens), {}, {
    colorText: 'rgba(255,255,255,0.88)'
  }),
  components: _objectSpread(_objectSpread({}, sharedComponents), {}, {
    Menu: {
      groupTitleColor: 'rgb(25, 166, 224)',
      itemColor: 'rgb(25, 166, 224)',
      itemHoverColor: 'rgb(25, 166, 224)',
      itemSelectedBg: 'rgba(255, 255, 255, 0.08)',
      itemSelectedColor: 'rgb(25, 166, 224)',
      subMenuItemBg: 'rgba(0, 0, 0, 0.15)'
    },
    Select: {
      colorPrimaryHover: 'rgba(255, 255, 255, 0.08)',
      multipleItemBg: 'rgba(255, 255, 255, 0)',
      optionSelectedColor: 'rgba(255,255,255,0.88)',
      optionSelectedBg: 'rgba(255, 255, 255, 0.08)'
    },
    Tag: {
      defaultColor: 'rgba(255,255,255,0.70)'
    },
    Dropdown: {
      controlItemBgActive: 'rgba(255, 255, 255, 0.12)',
      controlItemBgActiveHover: 'rgba(255, 255, 255, 0.16)'
    }
  })
};

// Legacy export for backwards compatibility
export var themeData = lightThemeData;